import { ICoreLogger } from "../api/ICoreLogger";
import { ICoreLoggerFactory } from "../api/ICoreLoggerFactory";
import { CoreLogger } from "./CoreLogger";
import { GLOBAL_LOGGER } from "./CoreLoggerConfigurator";
import { ILogger } from "js-logger";
import { Loggers } from "../../../../../index";

const Logger: ILogger = require("js-logger");
// const prettyPrintHierarchy = (loggers) => loggers.reduce((accumulator, current) => {
//     return accumulator.concat(current.name);
// }, []);
export const getLoggerHierarchyFor = (search: string = GLOBAL_LOGGER) => {
    if (search === GLOBAL_LOGGER) {
        return Array.from(Loggers.values());
    }

    let reg = new RegExp(`\\b${search}((\\.[a-zA-Z]+)?)*\\b`);
    let filtered: ICoreLogger[] = [];

    Loggers.forEach((value, key) => {
        if (reg.test(key)) {
            filtered.push(value);
        }
    });

    return filtered;
}

export class LoggerFactory implements ICoreLoggerFactory {
    // TODO @HTML5 might become useful for setting levels on "namespaces"    since currently from the library  you cannot get ALL the loggers available and set levels for them
    constructor(private _loggers: Map<any, ICoreLogger>) {
    }

    // TODO IMPROVEMENT  we might have a nested object instead of a Map (so all the filtering would be spared.  use lodash  .get .set .has .path  to create the object using the string passed as name)

    public getLoggerFor(value?: string): ICoreLogger {
        value = value || GLOBAL_LOGGER;
        if (!this._loggers.get(value)) {
            this._loggers.set(value, new CoreLogger(value === GLOBAL_LOGGER ? Logger : Logger.get(value)));
        }
        return this._loggers.get(value) as ICoreLogger;
    }

    public getLoggerForObject(value: any): ICoreLogger {
        return this.getLoggerForClass(value.constructor);
    }


    public getLoggerForClass(value: any): ICoreLogger {
        // TODO @HTML5  not tested yet, just transpiled
        if (!this._loggers.get(value)) {
            const className = this.getQualifiedClassName(value)
            this._loggers.set(value, this.getLoggerFor(className));
        }
        return this._loggers.get(value) as ICoreLogger;
    }

    getQualifiedClassName(instance: any): string {
        if (instance && instance.constructor) {
            return instance.constructor.name + ""
        }
        return instance + "";
    }

}

